import Oscar from "./Oscar.jsx";
import AnnouncementBanner from "./admin/AnnouncementBanner";

export default function App() {
  return (
    <>
      <AnnouncementBanner />
      <Oscar />
    </>
  );
}
